import { Model } from "@vuex-orm/core";
import shortid from "shortid";
import _ from "lodash";
import moment from "moment/moment";
import utils from "../../utils"

import RequestOrderProduct from "./RequestOrderProduct";
import PaymentMethod from "./PaymentMethod";
import RequestOrderService from "./RequestOrderService";
import RequestOrder from "./RequestOrder";

export default class RequestOrderPayment extends Model {
    static entity = "requestOrderPayments";
    static fields() {
        return {
            id: this.attr("tmp/" + shortid.generate()),
            paymentMethod: this.belongsTo(PaymentMethod,"paymentMethodId"),
            paymentMethodId: this.attr(null),
            requestOrderId: this.attr(null),
            amount: this.attr("0.00"),
            paid: this.attr(null),
            paidDatetime: this.attr(null),
            checked: this.attr(null),
            checkedDatetime: this.attr(null),
            code: this.attr(null),
            deadlineDatetime: this.attr(null),
            lastTriggeredUserId: this.attr(null),
            lastReceivedFromUserId: this.attr(null),
            received: this.attr(null),
            receivedDatetime: this.attr(null),
            dateUpdated: this.attr(null),
            dateCreated: this.attr(null),
            dateRemoved: this.attr(null),
        };
    }

    static beforeCreate(model) {
        if(model.requestOrderId && RequestOrder.find(model.requestOrderId)) {
            let paymentMethods = PaymentMethod.query().all()
            const requestOrderPayments = RequestOrderPayment.query().where('requestOrderId', model.requestOrderId).get()
            if(!Number.isInteger(model.paymentMethodId)) 
                paymentMethods.forEach(paymentMethod => {
                    if(paymentMethod.isDefault)
                        model.paymentMethodId = paymentMethod.id
                })
            if(requestOrderPayments.length == 0 && !Number.isInteger(model.id)) {
                const requestOrderProducts = RequestOrderProduct.query().where('requestOrderId', model.requestOrderId).get()
                const requestOrderServices = RequestOrderService.query().where('requestOrderId', model.requestOrderId).get()

                let totalAmount = _.sumBy(requestOrderServices, (requestOrderService) => {
                    return requestOrderService.price - requestOrderService.discount
                }) + _.sumBy(requestOrderProducts, (requestOrderProduct) => {
                    return (requestOrderProduct.unitPrice - requestOrderProduct.unitDiscount) * requestOrderProduct.quantity
                })

                model.amount = totalAmount.toFixed(2)
                model._generateCode(model)
            }
        }
    }

    _generateCode(model) {
        const currentPaymentMethod = PaymentMethod.find(model.paymentMethodId)
        if(currentPaymentMethod){
            if(_.isEmpty(model.code) && currentPaymentMethod.hasDeadline && model.code !== '') 
                model.code = utils.getShortCode()
            else if(!currentPaymentMethod.hasDeadline)
                model.code = null

            if(currentPaymentMethod.hasDeadline) {
                model.deadlineDatetime = 
                    currentPaymentMethod.deadlineRule 
                    ? moment(moment().add(parseInt(currentPaymentMethod.deadlineRule), 'days')).toISOString()
                    : moment().toISOString()
            }
        }
    }

}
